<template>
  <div v-if="visible" class="loading-overlay">
    <div class="loading-card">
        <!-- <img class="iconimg" src="@/assets/loadinggif.gif" alt=""> -->
        <img class="iconimg" :src=" require('@/assets/loadinggif.gif') " alt="">

          <div class="jindText">{{jindu}}%</div>

          <div class="text">{{text?text:'正在处理中，请稍后'}}</div>

          <div class="jindurq">
          <el-progress :percentage="jindu" :show-text="false" color="linear-gradient(to right, #9958fb, #00b5ff)"></el-progress>

          </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      visible: false,
      text: '正在处理中，请稍后',
      jindu: 0,
      intervalId: null
    }
  },
  watch: {
    visible(newval) {
      if (newval) {
        this.startProgress();
      } else {
        this.stopProgress();
        this.jindu = 100;
      }
    }
  },
  methods: {
    cardloading(bool, text) {
      if(bool) {
        this.visible = bool;
         this.text = text;
      }else {
        this.text = '处理即将完成'
        this.jindu = 100;
        setTimeout(() => {
          this.visible = bool;
        }, 500);
      }
    },
    startProgress() {
      this.jindu = 0;
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        if (this.jindu < 95) {
          this.jindu += Math.floor(Math.random() * 0.3) + 1;
          if (this.jindu > 95) {
            this.jindu = Math.floor(Math.random() * 4) + 96
          }
        }
      }, 200); // 每秒更新一次
    },
    stopProgress() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
  beforeDestroy() {
    this.stopProgress();
  }
}
</script>

<style scoped lang="scss">
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-card {
  padding-bottom:42.857142857142854px ;
  position: relative;
  width: 300px;
  height: 300px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 10px;
  .iconimg {
  width: 150.7142857142857px;
  margin: 0 auto;
  }
  .jindText {
    font-weight: 500;
    font-size: 22px;
    margin-bottom: 10px;
 }
  .text {
    margin-bottom: 15px;
  }
  .jindurq {
    width: 80%;
    
    margin: 0 auto;
  }
}

::v-deep .el-progress-bar__inner {
  background: linear-gradient(to right, #FF356E,#F34E2D, #FDBF5C) !important;
}
</style>